module.exports = __webpack_public_path__ + "img/630-f374b4.png";